<template>
  <div class="wind-hazard">
    <TheTopBar title="Wind Hazard Assessment" />
    <SurveyOverview @updateStep="$_goToSection" v-if="currentStep === 0" />
    <div class="row">

      <div class="app-padding">
        <div class="app-message" v-if="(!homeProfileProgressX || homeProfileProgressX < 80) && currentStep === 1">
          <div class="flexing">
            <div class="icon-col">
              <i class="material-icons-outlined">warning_amber</i>
            </div>
            <div class="content-col">
              <p>
                Please complete your <router-link :to="{ name: 'HomeProfile' }">Home Profile</router-link> before
                beginning
                the Wind Hazard Assessment. Selections made for Roof Type, Porches/Verandas and Garage/Carport in your
                Home Profile will affect the selection options available to you in the Wind Hazard Assessment. Once
                completed, you can update your Home Profile at any time.
              </p>
            </div>
          </div>
        </div>
        <form-builder ref="loanForm" :schema="schema" v-model="form" :stepper-data="stepper" @status="saveStatus"
          @stepStatus="updateStepStatus" :current-step="currentStep" isStepper :home-profile="homeProfile"
          v-if="ready && currentStep > 0" />
      </div>
    </div>
    <!--<div
      class="score-overview shadow-depth"
      id="v-step-1"
      :class="[scoreOverviewColorX]"
      v-if="currentStep < 4 && currentStep > 0"
    >
      {{ impactLevel }}
    </div> -->
    <div class="control-bar z-depth-1 row" v-if="currentStep > 0">
      <button class="btn btn-flat waves-effect btn-rounded white black-text col s5 m2" @click="$_goTo('overview')">
        Back
      </button>
      <router-link class="btn waves-effect btn-rounded col s5 m2 right" style="background:#5374F8; color:#fff;"
        v-if="currentStep === 4" :to="{ name: 'Home' }">
        Finish
      </router-link>
      <!--   <button
        class="btn waves-effect btn-rounded col s5 m2 right"
        style="background:#5374F8; color:#fff;"
        v-if="currentStep === 4"
        @click="$_goTo('finish')"
      >
        Finish
      </button> -->

      <button class="btn waves-effect btn-rounded col s5 m2 right" style="background:#5374F8; color:#fff;"
        :class="[status.invalid ? 'disabled' : 'shadow-depth']" @click="$_goTo()" v-if="currentStep < 4">
        Next
      </button>
    </div>
    <app-bottom-tab v-else />
    <keep-alive>

      <final-step v-if="currentStep === 4" :data-impact-level="impactLevel" @updateSelectedScore="$_updateScore"
        :dataSelectedScore="windHazardSurvey ? windHazardSurvey.score : {}" />

    </keep-alive>

    <!-- <TheSurveysTour @tourCallback="$_endTour()" /> -->
  </div>
</template>

<script>
import collapsibleComponent from '@/components/collapsible.component'
import FormBuilder from "@/components/formBuilder/FormBuilder.vue";
import { schema, impactLevelGenerator } from "@/schemas/windHazard.js";
import TheTopBar from "@/components/TheTopBar";
import AppBottomTab from "@/components/AppBottomTab";
import { mapActions, mapState } from "vuex";
import FinalStep from "@/components/TheSurveyFinalStep";
import { setDocumentBodyOverflowProperty } from "@/common/util";
// import { createSurvey, updateSurvey } from "@/api/survey.api";
import TheSurveysTour from "@/components/TheSurveysTour";
import SurveyOverview from "@/components/WindSurvey/SurveyOverview";

export default {
  name: "WindHazardSurvey",
  components: {
    FormBuilder,
    TheTopBar,
    FinalStep,
    TheSurveysTour,
    AppBottomTab,
    SurveyOverview,
    collapsibleComponent
  },
  data() {
    return {
      schema,
      routeResume: false,
      lastVisit: 0,
      ready: false,
      status: {
        invalid: false,
      },
      form: {},
      currentStep: 0,
      stepper: {
        stepStatus: false,
        canPrev: false,
        canNext: false,
      },
      impactLevel: "",
      shouldSave: false,
      userSelectedScore: "",
      userJustification: "",
      tagId: 38,
      section: "",
    };
  },

  /*  beforeRouteLeave(to, from, next) {
     if (
       to.name === "WindHazard" &&
       this.$store.state.Surveys.windHazardStarted
     ) {
       next({ name: "Home" });
     }
     next();
   }, */

  created() {
    // Redirect user to survey start page if user hasnt started survey
    if (!this.windHazardStarted) {
      this.$router.push({ name: "WindHazard" });
    }
  },

  mounted() {
    this.$_getData();
  },
  watch: {
    $route: function (nV) {

      this.lastVisit = this.currentStep
      if (nV && !nV.query || nV && !nV.query.editing) {
        this.$_goTo(1)
      } else if (nV && nV.query.editing) {
        //  if(nV.query.step) this.currentStep = nV
      }
      if (this.$route.query.step) {
        // this.routeResume = true
        this.currentStep = parseFloat(this.$route.query.step)
      }
    },
    currentStep: function (nV) {
      this.shouldSave = false
      nV < 1 && !this.routeResume
        ? '' //this.$router.replace({query:{}})
        : '' //this.$router.push({query:{editing:'true', section:nV, step:nV}})
    },
  },
  computed: {
    ...mapState({
      showTour: (state) => state.Surveys.showSurveyTour,
      windHazardSurvey: (state) => state.Surveys.windHazard,
      windHazardStarted: (state) => state.Surveys.windHazardStarted,
      user: (state) => state.User.user,
    }),
    windHazardImpact: {
      get() {
        let impacts = this.$_impactLevelGen()
        return {
          value: impacts['extreme-impact']
            ? 'Extreme Impact'
            : impacts['major-impact']  //&& !impacts['no-impact']
              ? 'Major Impact'
              : impacts['moderate-impact'] && !impacts['minor-impact'] && !impacts['no-impact']
                ? 'Moderate Impact'
                : impacts['minor-impact'] && !impacts['no-impact']
                  ? 'Minor Impact'
                  : impacts['no-impact']
                    ? 'No Impact'
                    : 'N/A',
          all: this.$_impactLevelGen()
        }

      }
    },
    homeProfile: {
      get() {
        return this.user.home_profile
          ? JSON.parse(this.user.home_profile)
          : false
      }
    },
    homeProfileProgressX() {
      return this.$store.getters["User/homeProfileProgress"];
    },
    scoreOverviewColorX() {
      switch (this.impactLevel) {
        case "Minor":
          return "light-blue-text lighten-3";
        case "Moderate":
          return "amber-text lighten-2";
        case "Major":
          return "orange-text lighten-3";
        case "Extreme":
          return "red-text lighten-3";
        default:
          return "black";
      }
    },
    surveyDataX() {
      return {
        survey: this.form,
        score: {
          generated: this.impactLevel,
          selected: this.userSelectedScore,
          justification: this.userJustification,
        },
        assessment: this.windHazardSurvey && this.windHazardSurvey.assessment ? this.windHazardSurvey.assessment : {}
      };
    },
  },
  methods: {
    ...mapActions("Surveys", {
      setShowSurveyTour: "SET_SHOW_SURVEY_TOUR",
      updateSurvey: "UPDATE_WIND_HAZARD",
    }),
    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll("[helper-id]");

      if (helpers) {
        helpers.forEach((helperEl) => {
          helperEl.addEventListener("click", (event) => {
            event.preventDefault()
            const helperId = helperEl.getAttribute("helper-id")
            const styles = helperEl.getAttribute("helper-style")
            this.$store.dispatch("Helpers/setHelper_", { id: helperId, styles: styles ? styles : '' })
            /*  this.$store.dispatch("Helpers/setHelper", helperId); */
          });
        });
      }
    },
    $_updateScore(val) {
      this.userSelectedScore = val.selected;
      this.userJustification = val.justification;
      this.$_saveData();
    },
    $_getData() {
      if (this.windHazardSurvey) {
        this.form = this.windHazardSurvey.survey;
        this.userSelectedScore = this.windHazardSurvey.score.selected;
        this.userJustification = this.windHazardSurvey.score.justification;
      }
      //console.log(this.$route)
      if (this.$route.query && this.$route.query.step) this.currentStep = parseInt(this.$route.query.step)
      this.ready = true;
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_endTour() {
      this.setShowSurveyTour(false);
      setDocumentBodyOverflowProperty("auto");
    },
    $_goTo(step = null) {
      if (this.shouldSave) this.$_saveData();
      if (step) {
        this.currentStep = 0;
        step === 'overview' ? this.$router.replace({ query: '' }) : ''
      } else {
        if (this.section === "roof") {
          this.currentStep = 2;
          this.section = "windows_doors";
        } else if (this.section === "windows_doors") {
          this.currentStep = 3;
          this.section = "walls_foundations";
        } else if (this.section === "walls_foundations") this.currentStep = 4
        else this.currentStep += 1


        this.$router.push({ query: { editing: true, section: this.currentStep, step: this.currentStep } })
        setTimeout(() => {
          this.$_setupHelpers();
        }, 300);
      }
      window.scrollTo(0, 0);
    },
    saveStatus(status) {
      Object.assign(this.status, status);
      this.getImpactLevel();
    },
    submit() {
      this.$refs.loanForm.validate();
      if (this.status.invalid) return;
    },
    updateStepStatus(stepInfo) {
      Object.assign(this.stepper, stepInfo);
      if (this.currentStep === 0) return;
      if (!stepInfo.isInitializing) this.shouldSave = true;
    },
    getImpactLevel() {
      this.impactLevel = this.windHazardImpact.value /* impactLevelGenerator(this.schema, this.form); */
    },
    $_goToSection({ step, section }) {
      this.currentStep = step;
      this.section = section;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_next(step) {
      if (step === "final") {
        this.$_saveData();
      }
      if (step === "finish") {
        this.$router.push({ name: "Home" });
      }
      this.currentStep++;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_prev() {
      this.currentStep--;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.$_setupHelpers();
      }, 300);
    },
    $_saveData() {
      // if (this.windHazardSurvey) {
      //   if (this.windHazardSurvey.id) {
      //     this.surveyDataX.id = this.windHazardSurvey.id;
      //   }
      // }
      this.updateSurvey(this.surveyDataX);
    },
    $_impactLevelGen() {
      const checkConditions = (o, v, is = true) => {

        return is
          ? this.form[o] && this.form[o] === v
          : this.form[o] && this.form[o] !== v && this.form[o] !== ''
      }
      const isTrue = x => x
      const roofCoreRes = ['roof_type', 'spaced_rafters', 'roofs_separated', 'garage_separated', 'roof_overhangs']

      let hasPorch =
        Array.isArray(this.homeProfile.porches_verandas_select)
        && this.homeProfile.porches_verandas_select.length === 1 && this.homeProfile.porches_verandas_select.findIndex(x => (x === 'no-roof' || x === 'none')) > -1

      let hasGarage =
        Array.isArray(this.homeProfile.garage_carport_select)
        && this.homeProfile.garage_carport_select.length === 1 && this.homeProfile.garage_carport_select.findIndex(x => x === 'none') > -1
      ///console.log(hasGarage)

      if (hasPorch) {
        let record_ = roofCoreRes.findIndex(p => p === 'roofs_separated')
        record_ > -1 ? roofCoreRes.splice(record_, 1) : ''
      }

      if (hasGarage) {

        let record_ = roofCoreRes.findIndex(p => p === 'garage_separated')
        record_ > -1 ? roofCoreRes.splice(record_, 1) : ''
      }

      const allCoreRoofFeatures = roofCoreRes.map(x => this.form[x]).every(isTrue)

      let unMeetCoreFeatures = roofCoreRes.filter(x => !this.form[x] || this.form[x] === '').length

      const coreWindow = this.form['windows_installation'] && this.form.windows_installation
      const coreDoor = this.form['door_installation_resiliency_features'] && this.form.door_installation_resiliency_features

      const allRoof = ['roof_type', 'spaced_rafters', 'roofs_separated', 'garage_separated', 'roof_overhangs', 'roof_covering', 'roof_fasteners', 'roof_covering_thickness']

      //  console.log(hasPorch, hasGarage)
      if (hasPorch) {

        let record = allRoof.findIndex(p => p === 'roofs_separated')
        record > -1 ? allRoof.splice(record, 1) : ''
      }

      if (hasGarage) {
        let record = allRoof.findIndex(p => p === 'garage_separated')
        record > -1 ? allRoof.splice(record, 1) : ''
      }

      const allroofFeatures = allRoof.map(x => this.form[x]).every(isTrue)

      // console.log( allRoof)
      let concreteRoof = Array.isArray(this.homeProfile.roof_type) && this.homeProfile.roof_type.length === 1 && this.homeProfile.roof_type.findIndex(x => x === 'Flat (Concrete slab)') > -1


      let filterIfConcrete = []
      let trueWithConcrete = []
      let coreTrueWithConcrete = []


      if (concreteRoof) {
        filterIfConcrete = allRoof.filter(y => ['spaced_rafters', 'roof_overhangs', 'roof_covering', 'roof_fasteners', 'roof_covering_thickness'].findIndex(u => u === y) < 0)
        trueWithConcrete = filterIfConcrete.map(x => this.form[x]).every(isTrue)
        coreTrueWithConcrete = roofCoreRes
          .filter(y => ['spaced_rafters', 'roof_overhangs', 'roof_covering', 'roof_fasteners', 'roof_covering_thickness'].findIndex(u => u === y) < 0)
          .map(x => this.form[x]).every(isTrue)

        unMeetCoreFeatures = roofCoreRes
          .filter(y => ['spaced_rafters', 'roof_overhangs', 'roof_covering', 'roof_fasteners', 'roof_covering_thickness'].findIndex(u => u === y) < 0)
          .filter(i => !this.form[i] || this.form[i] === '').length
      }
      const allWindow = ['window_type_features', 'windows_installation']
      const allWindowFeatures = allWindow.map(x => this.form[x]).every(isTrue)

      const allDoor = ['door_installation_resiliency_features', 'door_resiliency_features']
      const allDoorFeatures = allDoor.map(x => this.form[x]).every(isTrue)

      return {
        'no-impact': !concreteRoof
          ? allroofFeatures && checkConditions('roof_condition', 'good')
          && allWindowFeatures
          && checkConditions('window_only_condition', 'good')
          && allDoorFeatures && checkConditions('door_condition', 'good')
          && checkConditions('wall_condition', 'good')
          && checkConditions('foundation_condition', 'good')
          : trueWithConcrete && checkConditions('roof_condition', 'good')
          && allWindowFeatures
          && checkConditions('window_only_condition', 'good')
          && allDoorFeatures && checkConditions('door_condition', 'good')
          && checkConditions('wall_condition', 'good')
          && checkConditions('foundation_condition', 'good'),

        'minor-impact': !concreteRoof
          ? allroofFeatures
          && checkConditions('roof_condition', 'good')
          && coreWindow
          && coreDoor
          && checkConditions('window_only_condition', 'good')
          && checkConditions('door_condition', 'good')
          /*       && checkConditions('wall_condition', 'good')
                && checkConditions('foundation_condition', 'good')  */
          && checkConditions('wall_condition', 'poor', false)
          && checkConditions('foundation_condition', 'poor', false)
          : trueWithConcrete
          && checkConditions('roof_condition', 'good')
          && coreWindow
          && coreDoor
          && checkConditions('window_only_condition', 'good')
          && checkConditions('door_condition', 'good')
          /*     && checkConditions('wall_condition', 'good')
              && checkConditions('foundation_condition', 'good')  */
          && checkConditions('wall_condition', 'poor', false)
          && checkConditions('foundation_condition', 'poor', false),

        'moderate-impact':
          !concreteRoof
            ? (((allCoreRoofFeatures && checkConditions('roof_condition', 'poor', false))) || (allroofFeatures && checkConditions('roof_condition', 'fair')))

            && (checkConditions('wall_condition', 'poor', false) && checkConditions('foundation_condition', 'poor', false))

            && ((!coreWindow || !coreDoor) || ((checkConditions('window_only_condition', 'poor', false) || checkConditions('door_condition', 'poor', false))))

            ||

            ((!coreWindow || !coreDoor) || ((checkConditions('window_only_condition', 'poor', false) || checkConditions('door_condition', 'poor', false))))

            && (checkConditions('wall_condition', 'poor', false) && checkConditions('foundation_condition', 'poor', false))

            && checkConditions('roof_condition', 'poor', false) && allCoreRoofFeatures

            : (((coreTrueWithConcrete && checkConditions('roof_condition', 'poor', false))) || (coreTrueWithConcrete && checkConditions('roof_condition', 'fair')))

            && (checkConditions('wall_condition', 'poor', false) && checkConditions('foundation_condition', 'poor', false))

            && ((!coreWindow || !coreDoor) || ((checkConditions('window_only_condition', 'poor', false) || checkConditions('door_condition', 'poor', false))))

            ||

            ((!coreWindow || !coreDoor) || ((checkConditions('window_only_condition', 'poor', false) || checkConditions('door_condition', 'poor', false))))

            && (checkConditions('wall_condition', 'poor', false) && checkConditions('foundation_condition', 'poor', false))

            && checkConditions('roof_condition', 'poor', false)
        ,

        /*         'major-impact': unMeetCoreFeatures >= 1 || checkConditions('roof_condition', 'poor')
                                || (!coreWindow || !coreDoor || checkConditions('window_only_condition', 'poor') || checkConditions('door_condition', 'poor'))
                                || ( checkConditions('wall_condition', 'poor') || checkConditions('foundation_condition', 'poor'))
                                || unMeetCoreFeatures >= 1 || checkConditions('roof_condition', 'poor'), */
        'major-impact': (unMeetCoreFeatures >= 1 || checkConditions('roof_condition', 'poor'))
          && ((!coreWindow || !coreDoor || checkConditions('window_only_condition', 'poor') || checkConditions('door_condition', 'poor')))
          && (checkConditions('wall_condition', 'poor', false) || checkConditions('foundation_condition', 'poor', false))
          || unMeetCoreFeatures >= 1 || checkConditions('roof_condition', 'poor')
        ,

        'extreme-impact': ((unMeetCoreFeatures >= 1 || checkConditions('roof_condition', 'poor')) //changed made here to test
          && ((!coreWindow || !coreDoor) || (checkConditions('window_only_condition', 'poor') || checkConditions('door_condition', 'poor')))
          && ((checkConditions('wall_condition', 'poor') || checkConditions('foundation_condition', 'poor'))))
          || (checkConditions('wall_condition', 'poor') || checkConditions('foundation_condition', 'poor')),
        isConcreteRoof: filterIfConcrete
      }
    },
  }
};
</script>
<style lang="scss">
.roof-type-group {
  .row {
    margin: 0 !important;
  }

  .card-content {
    padding: 0 !important;
  }

  .roof_label {
    color: #707070;
    font-size: 18px !important;
  }
}

.video-id {
  width: 100%;

  iframe {
    width: 100%;
  }
}

.app-message {
  padding: 16px;
  background: #74f796;
  border-radius: 10px;
  margin-bottom: 12px;

  .flexing {
    display: flex;

    @media screen and (max-width: 680px) {
      flex-wrap: wrap;
    }

  }

  .icon-col {
    text-align: center;
    padding: 0 16px 0 10px;
    position: relative;

    @media screen and (max-width: 680px) {
      width: 100%;
    }

    i {
      font-size: 64px;
      transform: translateY(10%);
    }
  }

  .content-col {
    font-size: 14px;

    @media screen and (max-width: 680px) {
      width: 100%;
    }

    p {
      margin-top: 0px;
      margin-bottom: 8px;
    }
  }

  .assessment-action {
    padding-left: 80px;

    @media screen and (max-width: 680px) {
      padding-left: 0px;
    }
  }
}
</style>
<style lang="scss" scoped>
.wind-hazard {
  padding-bottom: 60px;

  .btn-save {
    position: fixed;
    bottom: 68px;
    right: 1rem;
    background: #5374f8;
    z-index: 9999;
  }

  .row {
    margin: 0;
  }

  .control-bar {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    width: 100%;
    padding: 1rem;
    margin: 0 !important;
    background: #fff;
    z-index: 900;
  }

  .score-overview {
    position: fixed;
    left: 50%;
    bottom: 68px;
    transform: translate(-50%, 0);
    background: #fff;
    border-radius: 30px;
    padding: 5px 10px;
    z-index: 1000;
  }

  .app-padding {
    padding: 16px 24px 0 24px;

    @media screen and (min-width: 1024px) {
      max-width: 768px;
      margin: auto;
    }
  }
}
</style>
<style lang="scss">
.wind-hazard {
  .section-head {
    font-size: 32px;
    font-family: "Libre Franklin", sans-serif;
    line-height: 34px;
    font-weight: 600;
    color: #f6be22;
  }
}
</style>
